import type { Space } from '@cocoonspace/sdk-js/types/space'
import { ResizablePanel } from '~/components/molecules/resizable-panel'
import { cardVariants } from '~/components/ui/card'
import {
	StepDate,
	StepNbPeople,
	StepStart,
} from '~/domains/spaces/components/space-details/desk-sidebar/desk-booking-stepper'
import { useDeskBookingStore } from './desk-booking.store'

export const DeskSidebar = ({ space }: { space?: Space }) => {
	const sidebarStep = useDeskBookingStore.use.sidebarStep()

	if (!space) return null

	return (
		<ResizablePanel
			className={cardVariants({
				className:
					'max-md:!fixed right-0 bottom-0 left-0 flex min-h-0 flex-col overflow-hidden max-md:z-20 max-md:rounded-b-none max-md:shadow md:sticky md:top-[108px]',
			})}
		>
			{sidebarStep === 'start' && <StepStart space={space} />}
			{sidebarStep === 'date' && <StepDate space={space} />}
			{sidebarStep === 'nbPeople' && <StepNbPeople space={space} />}
		</ResizablePanel>
	)
}
